var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288.154,
    height: 45.605,
    viewBox: "0 0 76.241 12.066",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style9"
  }, ".cls-3{fill:#72be44}.cls-1{fill:#eff1f6;fill-rule:evenodd}"))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-49.612 -69.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "matrix(.26458 0 0 .26458 44.606 54.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1052",
    transform: "matrix(.6515 0 0 .6515 198.197 58.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.05 55.16a.7.7 0 0 0-1.13-.06L58 62.4a4.82 4.82 0 0 0 7.62 5.89l6-7.15a.71.71 0 0 0-.39-1.14 10.87 10.87 0 0 1-6.18-4.84Z",
    id: "path15",
    style: {
      fill: "#ff3f46",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.233 25.607a4.81 4.81 0 0 0-7.28.4l-24.707 29.93 7.242 6.555 18.815-22.425a4.81 4.81 0 0 1 7.26-.4l4.89 5a.58.58 0 0 0 .86 0l4.46-5.71a.59.59 0 0 0 0-.74z",
    id: "path17",
    style: {
      fill: "#ff3f46",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.5 46.035 22.94-27.685c3.92-5.08-3.7-10.96-7.62-5.88l-23.18 27.47z",
    id: "path21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.09 59a4.81 4.81 0 0 0 7.29-.39L133 45.41a.57.57 0 0 0-.22-.89 10.67 10.67 0 0 1-6.23-5.52.56.56 0 0 0-1-.14L121 44.52a4.81 4.81 0 0 1-7.26.41l-4.89-5a.57.57 0 0 0-.85 0l-4.46 5.71a.56.56 0 0 0 0 .73z",
    id: "path23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m158.69 22.93-.12-11a3.6 3.6 0 0 0-3.57-3.3h-10.68a3.6 3.6 0 0 1-3.6-3.6V3.6a3.6 3.6 0 0 1 3.6-3.6h19a3.59 3.59 0 0 1 3.59 3.4l.2 19a3.59 3.59 0 0 1-3.59 3.8h-1.22a3.59 3.59 0 0 1-3.61-3.27z",
    id: "path27"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.03 7.817-.657.656a1.843 1.843 0 0 1-2.606 0l-.76-.76a1.787 1.787 0 0 1-.215-.264 2.37 2.37 0 0 1-1.654.667h-1.495c-.083 0-.165-.006-.247-.012a1.833 1.833 0 0 1-.535 1.267l-.658.657a1.845 1.845 0 0 1-2.605 0l-.658-.657a1.832 1.832 0 0 1-.535-1.267c-.082.005-.164.012-.247.012h-2.32v.112a2.937 2.937 0 0 1-2.935 2.934h-1.552V9.659h1.552a1.435 1.435 0 0 0 1.433-1.432V4.33h1.502v2.283h2.32a2.238 2.238 0 0 0 1.592-.659l1.15-1.149 1.152 1.15a2.238 2.238 0 0 0 1.591.658h1.495a.878.878 0 0 0 .59-.228 1.812 1.812 0 0 1-.265-.215l-.76-.76a1.841 1.841 0 0 1 0-2.605l1.96-1.958 2.064 2.062 2.302 2.302a1.84 1.84 0 0 1 0 2.605zm-9.231.009-.807-.806-.003-.003-.089-.089-.088.088-.81.81a.342.342 0 0 0 0 .482l.657.657a.342.342 0 0 0 .483 0l.658-.655a.342.342 0 0 0-.001-.484zm5.865-3.855-.13-.13-.872-.87-.899.897a.34.34 0 0 0 0 .483l.76.76a.342.342 0 0 0 .483 0l.658-.659a.342.342 0 0 0 0-.481zm2.304 2.303-1.001-1-.238.237-.003.003-.351.351.002.003-.322.322a.344.344 0 0 0-.086.222.338.338 0 0 0 .1.241l.76.76a.34.34 0 0 0 .482 0l.657-.657a.34.34 0 0 0 0-.483zM35.351 1.16h1.501v6.966h-1.501V1.158zm-2.717 6.39a1.843 1.843 0 0 1-2.606 0l-.658-.659a1.84 1.84 0 0 1 0-2.604l1.96-1.96 1.96 1.96a1.841 1.841 0 0 1 0 2.605zm-.405-2.202-.9-.899-.899.898a.34.34 0 0 0 0 .482l.657.658a.341.341 0 0 0 .483 0l.657-.657a.341.341 0 0 0 .002-.482zm-5.882 5.7a.39.39 0 0 1-.55 0l-.748-.749a.39.39 0 0 1 0-.55l1.024-1.023 1.023 1.023a.389.389 0 0 1 0 .55zm-1.799-2.923h-.91v.103a2.937 2.937 0 0 1-2.935 2.933h-1.826v-1.5h1.826a1.435 1.435 0 0 0 1.433-1.433v-.102h-1.27a1.844 1.844 0 0 1-1.842-1.842v-.929a1.844 1.844 0 0 1 1.842-1.842h.93a1.844 1.844 0 0 1 1.842 1.842v1.27h.91a1.161 1.161 0 0 0 1.161-1.16V3.512h1.502v1.952a2.664 2.664 0 0 1-2.663 2.66zM22.23 5.577l-.9-.898-.9.898a.341.341 0 0 0 0 .482l.658.657a.342.342 0 0 0 .483 0l.657-.657a.341.341 0 0 0 .002-.482zm-7.805 5.582h-1.826v-1.5h1.826a1.435 1.435 0 0 0 1.433-1.432V4.33h1.5v3.897a2.937 2.937 0 0 1-2.933 2.933zm-2.98-3.034h-1.35v-.917a2.775 2.775 0 0 1-2.061.917h-.57v.103a2.937 2.937 0 0 1-2.935 2.933H1.57A1.571 1.571 0 0 1 0 9.592v-6.08h1.502v6.08a.069.069 0 0 0 .068.068h2.958a1.435 1.435 0 0 0 1.433-1.432V3.512h1.501v3.112h.57a1.281 1.281 0 0 0 1.28-1.28V3.537h1.502v1.807a2.761 2.761 0 0 1-.313 1.28h.943a1.161 1.161 0 0 0 1.16-1.16V3.512h1.501v1.952a2.664 2.664 0 0 1-2.66 2.66z",
    id: "path238",
    style: {
      fill: "#fff",
      strokeWidth: 0.264583
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.9c42f7f51c16856b1ffb61c59051499f.svg";
export { ForwardRef as ReactComponent };